export default "__VITE_ASSET__C629JC3S__"